import { Create, Edit, SimpleForm } from 'react-admin';
import UserPersonalData from './UserPersonalData';
import UserProfessionalProfile from './UserProfessionalProfile';
import UserLoginContact from './UserLoginContact';
import { useState } from 'react';
import ConfirmUpdateEmailModal from './ConfirmUpdateEmailModal';
import ModalComponent from '../../../components/ModalComponent';
import { Toolbar, useRecordContext, useSaveContext, SaveButton, useNotify, useDataProvider, useResourceContext, useRedirect, Button } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { extractUfFromDocument, extractDocumentNumber } from '../../../utils/documentHelpers';


const messages = {
  success: 'Dados do usuário alterados com sucesso',
  error: 'Falha ao atualizar os dados do usuário',
}

const transformUserData = (data, isEdit = false) => {
  const { UF, documentNumber, typeUser, document, ...rest } = data;
  const typeUserValue = typeof typeUser === 'object' ? typeUser?.id : typeUser;
  const finalDocument = (documentNumber !== undefined && UF !== undefined) 
    ? (UF || '') + (documentNumber || '')
    : document;
  
  const typeUserField = isEdit ? 'typeUserId' : 'typeUser';
  
  return {
    ...rest,
    document: finalDocument,
    ...(typeUserValue !== undefined && { [typeUserField]: typeUserValue })
  };
};

const ConfirmingSaveToolbar = ({ edit }) => {
  const { handleSubmit } = useFormContext();
  const record = useRecordContext();
  const { saving, save } = useSaveContext();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const resource = useResourceContext();
  const redirect = useRedirect();
  const [modalOpen, setModalOpen] = useState(false);
  const [emailToSend, setEmailToSend] = useState(null);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const onClose = () => {
    setEmailToSend(null);
    setModalOpen(false);
  };

  const handleSaveWithoutSend = () => {
    notify(messages.success, { type: 'success' });
    onClose();
    redirect(`/${resource}`);
  };

  const onClickSave = (event) => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();

    handleSubmit(values => {
      const transformedValues = transformUserData(values, edit);

      if (edit && record) {
        const emailChanged = transformedValues?.email !== record?.email;
        const typeUserChanged = transformedValues?.typeUserId !== record?.typeUserId && 
        transformedValues?.typeUserId !== record?.typeUser?.id;
        const documentChanged = transformedValues?.document !== record?.document;
        
        if (emailChanged || typeUserChanged || documentChanged) {
          const payload = { ...transformedValues };
          dataProvider
            .update(resource, { id: record?.id, data: payload, previousData: record })
            .then(() => {
              if (emailChanged) {
                setEmailToSend(transformedValues.email);

                if(record?.isLoginLead === false && record?.isLoginSocial === false) {
                  setModalOpen(true);
                  return; 
                }
              }
              
              notify(messages.success, { type: 'success' });
              redirect(`/${resource}`);
            })
            .catch((e) => {
              if (e?.status === 400 && e?.message?.includes('Não encontramos o documento associado ao seu CPF no Conselho Federal de Medicina.')) {
                setErrorModalOpen(true);
              } else {
                notify(messages.error, { type: 'error' });
              }
            });
          return;
        }
      }
      
      save(transformedValues);
    })();
  };

  return (
    <>
      <Toolbar>
        <SaveButton onClick={onClickSave} disabled={saving} />
      </Toolbar>
      <ConfirmUpdateEmailModal
        open={modalOpen}
        onClose={onClose}
        onSaveWithoutSend={handleSaveWithoutSend}
        userId={record?.id}
        email={emailToSend || record?.email}
        loading={saving}
      />
      <ModalComponent
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        title={<span style={{ color: '#D32F2F', fontWeight: 'bold' }}>Erro ao validar CRM</span>}
        content={
          <p>
            Não encontramos o documento informado associado ao CPF no Conselho Federal de Medicina.
          </p>
        }
        actions={
          <Button onClick={() => setErrorModalOpen(false)} label="Voltar" />
        }
      />
    </>
  );
};



const parseDocument = (record) => {
  if (!record?.document) return record;
  return {
    ...record,
    UF: extractUfFromDocument(record.document),
    documentNumber: extractDocumentNumber(record.document),
  };
};

const userForm = (edit) => (
  <SimpleForm
    toolbar={<ConfirmingSaveToolbar edit={edit} />}
    defaultValues={edit ? parseDocument : undefined}
  >
    <div style={{ marginTop:'24px', display: 'flex', flexDirection: 'row', gap: '48px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <UserPersonalData edit={edit} />
      </div>
      <UserLoginContact edit={edit} />
    </div>
    <UserProfessionalProfile edit={edit} />
  </SimpleForm>
);

export const UserCreate = (props) => (
  <Create redirect="list" {...props} title="Novo Usuário">
    {userForm()}
  </Create>
);

export const UserEdit = (props) => (
  <Edit redirect="list" {...props} title="Editar Usuário">
    {userForm(true)}
  </Edit>
);
